document.addEventListener('DOMContentLoaded', () => {

  if(!document.querySelector('.mux-video')) return

  const HIDE_DELAY = 1200;

  // Les vidéos Mux sont en HLS (.m3u8), lu nativement par Safari seulement.
  // Ailleurs (Chrome, Firefox, Edge…), on passe par hls.js via MediaSource.
  const hasMSE = !!(window.MediaSource || window.ManagedMediaSource);
  let hlsLibPromise = null;
  const loadHlsLib = (url) => {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!hlsLibPromise) {
      hlsLibPromise = new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = url;
        s.async = true;
        s.onload = () => (window.Hls ? resolve(window.Hls) : reject(new Error("hls.js absent")));
        s.onerror = () => reject(new Error("hls.js non chargé"));
        document.head.appendChild(s);
      });
    }
    return hlsLibPromise;
  };

  // Branche hls.js sur la vidéo sans rien télécharger avant le premier play
  // (équivalent de preload="metadata"). Renvoie une fonction qui lance le chargement.
  const setupHls = (root, v) => {
    const src = root.dataset.hlsSrc;
    const lib = root.dataset.hlsLib;
    if (!src || !lib || !hasMSE) return Promise.resolve(() => {});
    return loadHlsLib(lib)
      .then((Hls) => {
        if (!Hls.isSupported()) return () => {};
        const hls = new Hls({ autoStartLoad: false });
        hls.loadSource(src);
        hls.attachMedia(v);
        let started = false;
        return () => {
          if (started) return;
          started = true;
          hls.startLoad();
        };
      })
      .catch((e) => {
        console.log(e);
        return () => {};
      });
  };

  document.querySelectorAll(".mux-video").forEach((root) => {
    const player = root.querySelector("[data-player]");
    const v = root.querySelector("[data-video]");
    const bigPlay = root.querySelector("[data-bigplay]");
    const controls = root.querySelector("[data-controls]");
    const btn = root.querySelector("[data-btn]");
    const bar = root.querySelector("[data-bar]");
    const fill = root.querySelector("[data-fill]");
    const fsBtn = root.querySelector("[data-fs]");

    if (
      !player ||
      !v ||
      !bigPlay ||
      !controls ||
      !btn ||
      !bar ||
      !fill ||
      !fsBtn
    )
      return;

    const btnPlayIcon = btn.querySelector('[data-icon="play"]');
    const btnPauseIcon = btn.querySelector('[data-icon="pause"]');

    let hasStarted = false;
    let hideTimer = null;

    const hlsReady = setupHls(root, v);
    const play = async () => {
      (await hlsReady)();
      await v.play();
    };

    const stopOthers = () => {
      document.querySelectorAll("video").forEach((other) => {
        if (other !== v) other.pause();
      });
    };

    const showControls = () => {
      if (!hasStarted || v.paused) return;
      controls.classList.remove("opacity-0", "pointer-events-none");
      controls.classList.add("opacity-100");
    };

    const hideControls = () => {
      controls.classList.add("opacity-0", "pointer-events-none");
      controls.classList.remove("opacity-100");
    };

    const scheduleHide = () => {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        if (!v.paused && !v.ended) hideControls();
      }, HIDE_DELAY);
    };

    const setBtnIcon = () => {
      const playing = !v.paused && !v.ended;
      if (btnPlayIcon) btnPlayIcon.classList.toggle("hidden", playing);
      if (btnPauseIcon) btnPauseIcon.classList.toggle("hidden", !playing);
    };

    const updateProgress = () => {
      if (!Number.isFinite(v.duration) || v.duration === 0) return;
      fill.style.width = `${(v.currentTime / v.duration) * 100}%`;
    };

    const seek = (e) => {
      if (!Number.isFinite(v.duration) || v.duration === 0) return;
      const rect = bar.getBoundingClientRect();
      const x = Math.min(Math.max(0, e.clientX - rect.left), rect.width);
      v.currentTime = (x / rect.width) * v.duration;
      updateProgress();
    };

    // Big play: visible tant que la vidéo est en pause (masqué pendant la lecture)
    bigPlay.addEventListener("click", async () => {
      try {
        hasStarted = true;
        stopOthers();
        await play();
      } catch (e) {
        console.log(e);
      }
    });

    // Clic sur l'image : met en pause (le gros play reprend la main)
    v.addEventListener("click", () => {
      if (!v.paused) v.pause();
    });

    // Small play/pause
    btn.addEventListener("click", async () => {
      try {
        if (v.paused) {
          stopOthers();
          await play();
          scheduleHide();
        } else {
          v.pause();
        }
      } catch (e) {
        console.log(e);
      }
    });

    // Progress click-to-seek
    bar.addEventListener("click", (e) => {
      seek(e);
      showControls();
      scheduleHide();
    });

    // Drag-to-seek (pointer)
    bar.addEventListener("pointerdown", (e) => {
      bar.setPointerCapture?.(e.pointerId);
      seek(e);
      showControls();

      const move = (ev) => seek(ev);
      const up = () => {
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);
        scheduleHide();
      };

      window.addEventListener("pointermove", move);
      window.addEventListener("pointerup", up);
    });

    // Fullscreen
    fsBtn.addEventListener("click", async () => {
      try {
        const el = player;

        if (!document.fullscreenElement) {
          if (el.requestFullscreen) {
            await el.requestFullscreen();
          } else if (v.webkitEnterFullscreen) {
            // iOS Safari fallback
            v.webkitEnterFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            await document.exitFullscreen();
          } else if (v.webkitExitFullscreen) {
            v.webkitExitFullscreen();
          }
        }

        showControls();
        scheduleHide();
      } catch (e) {
        console.log(e);
      }
    });

    // Show controls on movement, then auto-hide
    player.addEventListener("mousemove", () => {
      if (!hasStarted) return;
      showControls();
      scheduleHide();
    });

    player.addEventListener(
      "touchstart",
      () => {
        if (!hasStarted) return;
        showControls();
        scheduleHide();
      },
      { passive: true }
    );

    // Video events
    // En pause : gros play affiché, contrôles masqués
    const showBigPlay = () => {
      setBtnIcon();
      clearTimeout(hideTimer);
      hideControls();
      bigPlay.classList.remove("hidden");
    };

    v.addEventListener("play", () => {
      bigPlay.classList.add("hidden");
      setBtnIcon();
      showControls();
      scheduleHide();
    });

    v.addEventListener("pause", showBigPlay);
    v.addEventListener("ended", showBigPlay);

    v.addEventListener("timeupdate", updateProgress);
    v.addEventListener("loadedmetadata", updateProgress);

    // INIT
    hideControls(); // hidden before first play
    setBtnIcon();
    updateProgress();
  });
})
